var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretRightCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.148,407.505a13.5,13.5,0,1,1-13.5,13.5A13.516,13.516,0,0,1,298.148,407.505Zm0,26a12.5,12.5,0,1,0-12.5-12.5A12.515,12.515,0,0,0,298.148,433.505Z",
    transform: "translate(-284.648 -407.505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.049,415.112a.537.537,0,0,1,.754,0l5.449,5.45a.6.6,0,0,1,0,.8l-5.454,5.455a.537.537,0,0,1-.758,0,.541.541,0,0,1,0-.754l5.1-5.094-5.1-5.1A.536.536,0,0,1,295.049,415.112Z",
    transform: "translate(-284.649 -407.505)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretRightCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caret-right-circle.cc1c6060.svg";
export { ForwardRef as ReactComponent };